import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
  /** Compact mode — less vertical padding, smaller text */
  compact?: boolean;
}

export function EmptyState({ icon, title, description, action, className, compact = false }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        compact ? 'py-6 px-4' : 'py-10 px-6',
        className,
      )}
    >
      {icon ? (
        <div className={cn('text-ink-300 mb-3', compact && 'mb-2 scale-75')}>
          {icon}
        </div>
      ) : null}
      <h4 className={cn('font-display font-semibold text-ink-700', compact && 'text-sm')}>
        {title}
      </h4>
      {description ? (
        <p className={cn('mt-1 text-ink-400 max-w-xs leading-snug', compact ? 'text-[11px]' : 'text-xs')}>
          {description}
        </p>
      ) : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
